import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getActiveBrands = createAsyncThunk('/GetActiveBrands', async () => {
  const response = await axios.get(`/GetActiveBrands`);
  return response.data;
});
export const getBrandsByName = createAsyncThunk('/GetBrandsByName', async (req) => {
    const response = await axios.get(`/GetBrandsByName/${req}`);
    return response.data;
  });
export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);
export const setBrandTenantMap = createAsyncThunk('/SetBrandTenantMap', async (req) => {
  const response = await axios.post(`/SetBrandTenantMap`, req);
  return response.data;
});

const brandSlice = createSlice({
  name: 'brand',
  initialState: {
    loading: '',
    error: '',
    activeBrands: [],
    searchedBrands: []
  },
  reducers: {
    resetBrands(state) {
      state.activeBrands = []
      state.searchedBrands = [];
    },
  },
  extraReducers: {

    [getActiveBrands.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getActiveBrands.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getActiveBrands.fulfilled]: (state, action) => {
      state.activeBrands = action.payload;
      state.loading = 'Finished';
    },
    [getBrandsByName.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getBrandsByName.rejected]: (state, action) => {
        state.error = action.payload;
    },
    [getBrandsByName.fulfilled]: (state, action) => {
        state.searchedBrands = action.payload;
        state.loading = 'Finished';
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.ServiceShopTypeDescriptions = action.payload;
      state.loading = 'Finished';
    }


  }
});
export const brandActions = brandSlice.actions;
export default brandSlice;
